<template>
    <v-container fluid class="pt-0">
        <v-row>

            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-account</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Registro total de Docentes</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ items.length }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px">

                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                    >

                    <template v-slot:top>
                        <v-container class="py-0">
                            <v-row justify="center" align="center">
                                <v-col cols="12" lg="6">

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark>
                                                <v-icon>mdi-account-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Nuevo registro</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark>
                                                <v-icon>mdi-file-pdf</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Exportar</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="calendar_dialog = !calendar_dialog" dark>
                                                <v-icon>mdi-calendar</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Horarios</span>
                                    </v-tooltip>

                                </v-col>
                                <v-col cols="12" lg="6">
                                    <v-text-field
                                        v-model="search"
                                        clearable
                                        dense
                                        outlined
                                        hide-details
                                        label="Buscar"
                                        append-icon="mdi-magnify"
                                        color="#818181"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>

                    <template v-slot:item.authorized="{ item }">
                        <v-chip color="success" v-if="item.authorized">Autorizado</v-chip>
                        <v-chip color="error" v-else>No autorizado</v-chip>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <v-chip color="success" v-if="item.status">Habilitado</v-chip>
                        <v-chip color="error" v-else>Deshabilitado</v-chip>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-account-edit</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item class="px-0">
                                    <v-list-item-content>
                                        <v-btn small text @click="show(item)">Mostrar</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-content>
                                        <v-btn small text @click="edit(item)">Editar</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-content>
                                        <v-btn small text @click="status(item)">{{ item.status ? 'Deshabilitar': 'Habilitar' }}</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0" v-if="!item.authorized">
                                    <v-list-item-content>
                                        <v-btn small text @click="authorized(item)">Autorizar</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-content>
                                        <v-btn small text @click="remove(item)">Eliminar</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-menu</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item class="px-0">
                                    <v-list-item-content>
                                        <v-btn small text @click="() => { recordings_dialog = true; recordings_item = item }">Grabaciones</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="recordings_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="recordings_item">
                <v-toolbar flat color="#008dd4" dark>
                    <v-btn icon @click="recordings_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Grabaciones - {{ recordings_item.fullname }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" lg="3" md="3" sm="12">
                                <v-card>
                                    <v-card-title>Total de Grabaciones</v-card-title>
                                    <v-card-text>
                                        <div class="text-h4">
                                            {{ recordings_item.recordings.length }}
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" lg="9" md="9" sm="12">
                                <v-card>
                                    <v-card-text>
                                        <v-data-table
                                            :headers="headers_recordings"
                                            :items="recordings_item.recordings"
                                            :loading="loading"
                                            :footer-props="footer_props"
                                            :loading-text="loading_text"
                                            :no-data-text="no_data_text"
                                            :no-results-text="no_result_text"
                                            :search="search"
                                        >
                                            <template v-slot:item.video="{ item }">
                                                <v-btn icon @click="() => { watch_item = item; watch = true }">
                                                    <v-icon>mdi-video-box</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="watch" max-width="900" persistent>
            <v-card v-if="watch_item">
                <v-card-title>{{ watch_item.name }}</v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <span v-html="watch_item.iframe"></span>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="reset_watch">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="calendar_dialog" fullscreen   hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="calendar_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Calendario</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="calendar_dialog = false" >Save</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                
                <div>
                    <v-sheet tile height="54" class="d-flex">
                        <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="type"></v-select>
                        <v-select v-model="teacher_selected" :items="items" item-value="id" item-text="fullname" @change="selectTeacher" dense outlined hide-details label="Maestros" class="ma-2"></v-select>
                        <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays" class="ma-2"></v-select>
                        <v-spacer></v-spacer>
                        <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-sheet>
                    <v-sheet height="600">
                    <v-calendar
                        ref="calendar"
                        v-model="value"
                        :weekdays="weekday"
                        :type="type"
                        :events="events"
                        :event-overlap-mode="mode"
                        :event-overlap-threshold="30"
                        :event-color="getEventColor"
                        @change="getEvents"
                    ></v-calendar>
                    </v-sheet>
                </div>
            </v-card>
        </v-dialog>

        <authorized :dialog="authorized_dialog" :item="authorized_item" :store_url="store_url"></authorized>

    </v-container>
</template>
<script>

import authorized from './authorized'

export default {
    components:{
        authorized
    },

    data: () => ({
        //calendar
        type: 'month',
        types: ['month', 'week', 'day', '4day'],
        mode: 'stack',
        modes: ['stack', 'column'],
        weekday: [0, 1, 2, 3, 4, 5, 6],
        teacher_selected : null,
        weekdays: [
            { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
            { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
            { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
            { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
        ],
        value: '',
        events: [],
        full_events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        

        //urls
        data_url:"/teachers",
        store_url:"/teachers/authorized",

        //dialogs
        authorized_dialog : false,
        calendar_dialog : false,

        //items
        authorized_item : [],

        //recordings_dialog
        recordings_dialog:false,
        recordings_item:"",
        watch_item:"",
        watch:false,

        //props
        items:[],

        //data table props
        color:"#008dd4",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID',          value:'id' },
            { text:'Nombre(s)',   value:'fullname' },
            { text:'Teléfono',    value:'phone'},
            { text: 'Autorizado', value: 'authorized' },
            { text:'status',      value:'status' },
            { text: 'Acciones',   value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        },

        //recordings data table
        headers_recordings:[
            { text:'ID',        value:'id' },
            { text:'Curso',     value:'course.name' },
            { text:'Nivel',     value:'course.level.name' },
            { text:'Modalidad', value:'course.modality.name'},
            { text:'Horario',   value:'course.schedule[0].start_time' },
            { text:'Video',     value:'video' },
            { text: 'Registro', value:'realDate'}
        ],
    }),

    mounted(){
        this.getData()
    },

    methods:{
        selectTeacher () {
            this.events = this.full_events.filter( event => {
                if(this.teacher_selected == event.user_id)
                    return event;
            })
        },
        getEvents ({ start, end }) {
            const events = []

            const min = new Date(`${start.date}T00:00:00`)
            const max = new Date(`${end.date}T23:59:59`)
            const days = (max.getTime() - min.getTime()) / 86400000
            const eventCount = this.rnd(days, days + 20)

            for (let i = 0; i < eventCount; i++) {
                const allDay = this.rnd(0, 3) === 0
                const firstTimestamp = this.rnd(min.getTime(), max.getTime())
                const first = new Date(firstTimestamp - (firstTimestamp % 900000))
                const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
                const second = new Date(first.getTime() + secondTimestamp)

                events.push({
                    name: this.names[this.rnd(0, this.names.length - 1)],
                    start: first,
                    end: second,
                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: !allDay,
                })
            }

            // this.events = events
        },
        getEventColor (event) {
            return event.color
        },
        rnd (a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
        getData:function(){
            axios.get(this.data_url, { params:{ ajax:true }}).then(response => {
                this.items = response.data.items
                this.full_events = response.data.events
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },

        getItem:function(item){
            return Object.assign({}, this.items[this.items.indexOf(item)])
        },

        show:function(item){},

        edit:function(item){},

        status:function(item){},

        authorized:function(item){
            this.authorized_item = this.getItem(item)
            this.authorized_dialog = true
        },

        reset_watch:function(){
            this.watch_item = ""
            this.watch = false
        },

        remove:function(item){}
    }
}
</script>
